// extracted by mini-css-extract-plugin
export default {"imageCardItem":"product_detail_imageCardItem__d491g","rotateActions":"product_detail_rotateActions__3BxSc","imageListItem":"product_detail_imageListItem__4YXhe"};